import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/shared/button/Button';
import './WorkOrderValueEditor.css';
import Input from 'components/shared/input/Input';

export default function WorkOrderValueEditor(props) {
  const handleClick = () => {
    if (props.edit) {
      if (props.onSave) {
        props.onSave();
      }
    } else {
      if (props.onEdit) {
        props.onEdit();
      }
    }
  };

  const handleChange = (value) => {
    if (props.onValueChange) {
      props.onValueChange(value);
    }
  };

  let buttonLabel;
  if (props.edit) {
    if (props.saving) {
      buttonLabel = 'Saving...';
    } else {
      buttonLabel = 'Save';
    }
  } else {
    buttonLabel = 'Edit';
  }
  return (
    <div className="work-order-value-editor">
      <div className="small-bold wove-label">{props.label}</div>
      <div className="wove-row">
        {props.edit ? (
          <Input
            readOnly={props.saving}
            value={props.value}
            onChange={handleChange}
          />
        ) : (
          <div className="small-regular">{props.value}</div>
        )}
        {props.canEdit && (
          <div>
            <Button
              className="button-orange"
              disabled={props.saving}
              label={buttonLabel}
              onClick={handleClick}
            />
          </div>
        )}
      </div>
    </div>
  );
}

WorkOrderValueEditor.propTypes = {
  canEdit: PropTypes.bool,
  edit: PropTypes.bool,
  label: PropTypes.string.isRequired,
  saving: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
};

WorkOrderValueEditor.defaultProps = {
  canEdit: true,
  edit: false,
  saving: false,
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/WorkOrderValueEditor.js